import React from 'react';
import ConnectBrokerContent from '../../broker/ConnectBrokerContent';

/** Connect-broker step inside the shared orientation modal shell. */
export default function OrientationConnectStep({ onBusyChange }) {
  return (
    <div className="orientation-connect-step connect-broker-modal-body">
      <ConnectBrokerContent onBusyChange={onBusyChange} />
    </div>
  );
}
